// import { extend, localize } from "vee-validate";
import { extend, localize } from "vee-validate/dist/vee-validate.esm.js";
import { min, required, email, max } from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

// install rules
extend("required", required);
extend("min", min);
extend("max", max);
extend("email", email);
extend("select", {
  validate(value: number, { min = 1 }: any) {
    return value >= Number(min);
  },
  params: ["min"],
  message: "This {_field_} field is required"
});

extend("phone", {
  validate(value: string) {
    var regex = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;
    return regex.test(value);
  },
  message: "This {_field_} field is not a valid phone number"
});

extend("domainmail", {
  validate(value: string) {
    var regex = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;
    var result = regex.test(value);
    if (!result) {
      regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      result = regex.test(value);
    }
    return result;
  },
  message: "This {_field_} field is not a valid domain or mail"
});

// install messages
localize({
  en
});
